import React, { Component } from "react";
import { Button, Form } from "semantic-ui-react";
import DropzoneCommon from "../../components/content/DropzoneCommon"

export const imageElement = {
  backgroundImage: `url(https://via.placeholder.com/300)`,
  backgroundRepeat: "no-repeat",
  backgroundAttachment: "scroll",
  backgroundPosition: "center center",
  backgroundSize: "cover",
  display: "block",
  height: "300px",
  left: "0px",
  position: "absolute",
  top: "0px",
  width: "300px",
  content: "",
  label: "Image",
  type: "image",
  editable: true
};
class ImageForm extends Component {
  state = {};
  render() {
    const {
      element: elem,
      id: i,
      update,
      drop,
      delete: trash,
      title
    } = this.props;
    return (
      <Form>
        {title}
        <DropzoneCommon
          onDrop={files => drop(i, files[0])}
          accept="image/*"
          acceptClassName="green"
          activeClassName="secondary"
          rejectClassName="red"
          className="ui dropzone"
          />
        <label>Size</label>
        <Button.Group widths="3">
          <Button
            icon="compress"
            onClick={e => update(i, "backgroundSize", "contain")}
            active={elem["backgroundSize"] === "contain"}
          />
          <Button
            icon="expand arrows alternate"
            onClick={e => update(i, "backgroundSize", "cover")}
            active={elem["backgroundSize"] === "cover"}
          />
          <Button
            icon="refresh"
            onClick={e => update(i, "backgroundSize", "auto")}
            active={elem["backgroundSize"] === "auto"}
          />
        </Button.Group>
        {elem.type === "image" && (
          <div>
            <Form.Field inline>
              <label style={{ width: "100px" }}>top {elem["top"]}</label>
              <input
                type="range"
                min="0"
                max="1080"
                step="1"
                name={`element-${i}-top`}
                value={elem["top"].replace("px", "")}
                onChange={e => update(i, "top", `${e.target.value}px`)}
              />
            </Form.Field>
            <Form.Field inline>
              <label style={{ width: "100px" }}>left: {elem["left"]}</label>
              <input
                type="range"
                min="0"
                max="1920"
                step="1"
                name={`element-${i}-left`}
                value={elem["left"].replace("px", "")}
                onChange={e => {
                  update(i, "left", `${e.target.value}px`);
                }}
              />
            </Form.Field>
            <Form.Field inline>
              <label style={{ width: "100px" }}>width {elem["width"]}</label>
              <input
                type="range"
                min="50"
                max="1920"
                step="1"
                name={`element-${i}-width`}
                value={elem["width"].replace("px", "")}
                onChange={e => {
                  let curWidth = parseInt(elem["width"]);
                  let curHeight = parseInt(elem["height"]);
                  let ratio = e.target.value / curWidth;
                  let height = Math.ceil(curHeight * ratio);
                  if (height > 1080) return false;
                  update(i, {
                    width: `${e.target.value}px`,
                    height: `${height}px`
                  });
                }}
              />
            </Form.Field>
            <Form.Field inline>
              <label style={{ width: "100px" }}>height: {elem["height"]}</label>
              <input
                type="range"
                min="50"
                max="1080"
                step="1"
                name={`element-${i}-height`}
                value={elem["height"].replace("px", "")}
                onChange={e => {
                  let curWidth = parseInt(elem["width"]);
                  let curHeight = parseInt(elem["height"]);
                  let ratio = e.target.value / curHeight;
                  let width = Math.ceil(curWidth * ratio);
                  if (width > 1920) return false;

                  update(i, {
                    height: `${e.target.value}px`,
                    width: `${width}px`
                  });
                }}
              />
            </Form.Field>
          </div>
        )}
        {(elem.type === "image" || elem.type === "background") && (
          trash && (
            <Button
              fluid
              color="red"
              icon="trash"
              onClick={e => {
                trash(i);
              }}
            />
          )
        )}
      </Form>
    );
  }
}

export default ImageForm;
